import { endpointHelpers } from '../../../features/serverBots/endpointHelpers'

export function useBotPrimaryColor() {
  const config = endpointHelpers.getConfigurationForCurrentBot.useQueryData()?.configuration

  return config?.designerTheme?.primaryColor || ''
}
